import { Button, Text, VStack } from "@chakra-ui/react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState } from 'react'
import { LoginWithCode } from "../../../services/Auth"

const SsoCallbackPage = () => {
    const [searchParams] = useSearchParams()
    const [is_login_success, setIsLoginSuccess] = useState<boolean>(true)
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            try {
                const code = searchParams.get('code')
                await LoginWithCode(code as string)
                window.location.href = '/get-in'
            } catch (e) {
                console.log('got error')
                setIsLoginSuccess(() => false)
            }
        })()
    }, [searchParams])

    return (
        <VStack w={'full'} h={'100vh'} justify={'center'}>
            {is_login_success &&
                <Text fontSize={'3xl'}>Authenticating, please wait . . .</Text>
            }
            {!is_login_success &&
                <VStack w={'full'} spacing={16}>
                    <VStack spacing={0}>
                        <Text fontSize={'3xl'}>Failed to authenticate user, </Text>
                        <Text fontSize={'3xl'}>please try again later</Text>
                    </VStack>
                    <Button onClick={() => navigate('/login')} colorScheme={'blue'}>Back to login</Button>
                </VStack>
            }
        </VStack>
    )
}

export default SsoCallbackPage